import { FaRegUserCircle } from "react-icons/fa";
import { HiOutlineWallet, HiWallet } from "react-icons/hi2";
import {
  MdAccountCircle,
  MdDashboard,
  MdGridView,
  MdOutlineShoppingBag,
  MdShoppingBag
} from "react-icons/md";
import { GiReturnArrow } from "react-icons/gi";
import { FiPackage } from "react-icons/fi";
import { RiMoneyDollarBoxLine, RiMoneyPoundBoxFill } from "react-icons/ri";
import { useLocation, useNavigate } from "react-router-dom";
import { assets } from "../../Assets/assets";
import { useAuth } from "../Context/AuthContext";

const MobileBottomNav = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { user } = useAuth();

  const isSupplier = user?.role === "supplier";

  const tabs = isSupplier
    ? [
        {
          label: "Home",
          icon: <img src={assets.homeinactive} alt="logo" className="w-[1.33rem]" />,
          icon1: <img src={assets.homeactive} alt="logo" className="w-6" />,
          path: "/",
        },
        {
          label: "Live Orders",
          icon: <MdOutlineShoppingBag />,
          icon1: <MdShoppingBag />,
          path: "/supplier-orders",
        },
        {
          label: "Returns",
          icon: <GiReturnArrow />,
          icon1: <GiReturnArrow />,
          path: "/returns",
        },
        {
          label: "Linked",
          icon: <FiPackage />,
          icon1: <FiPackage />,
          path: "/supplier-linked-varieties",
        },
        {
          label: "Account",
          icon: <FaRegUserCircle />,
          icon1: <MdAccountCircle />,
          path: "/account",
        },
      ]
    : [
        {
          label: "Home",
          icon: <img src={assets.homeinactive} alt="logo" className="w-[1.33rem]" />,
          icon1: <img src={assets.homeactive} alt="logo" className="w-6" />,
          path: "/",
        },
        {
          label: "Orders",
          icon: <MdOutlineShoppingBag />,
          icon1: <MdShoppingBag />,
          path: "/orders",
        },
        {
          label: "Quotations",
          icon: <RiMoneyDollarBoxLine />,
          icon1: <RiMoneyPoundBoxFill />,
          path: "/quotations",
        },
        {
          label: "Returns",
          icon: <GiReturnArrow />,
          icon1: <GiReturnArrow />,
          path: "/returns",
        },
        {
          label: "Account",
          icon: <FaRegUserCircle />,
          icon1: <MdAccountCircle />,
          path: "/account",
        },
      ];

  return (
    <div className="fixed bottom-0 left-0 w-full bg-white border-t shadow-md z-50 md:hidden">
      <div className="flex justify-around items-center py-2">
        {tabs.map((tab, index) => {
          const isActive = location.pathname === tab.path;

          return (
            <button
              key={index}
              onClick={() => navigate(tab.path)}
              className={`flex flex-col items-center text-sm transition
                ${isActive ? "text-primaryColor" : "text-gray-400"}
              `}
            >
              <div className="text-2xl">{isActive ? tab.icon1 : tab.icon}</div>
              <span className="font-medium">{tab.label}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default MobileBottomNav;